export function clear(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] instanceof Array) {
      obj[key] = [];
    } else {
      obj[key] = "";
    }
  });
}

export function transformToTree(parents, children) {
  parents.forEach((parent) => {
    children.forEach((current) => {
      if (current.funcHighId === parent.funcId) {
        transformToTree([current], children);
        parent.children.push(current);
      }
    });
  });
}

export function extractSelectedTreeNodeId(nodeId, checkedNodes) {
  checkedNodes.forEach((node) => {
    if (node.parent != null) {
      extractSelectedTreeNodeId(nodeId, [node.parent]);
    }
    if (!nodeId.includes(node.id)) {
      nodeId.push(node.id);
    }
  });
}

export function transformToMenuTree(parents, children) {
  parents.forEach((parent) => {
    children.forEach((current) => {
      if (current.menuHighId === parent.menuId) {
        transformToTree([current], children);
        parent.subMenu.push(current);
      }
    });
  });
}

export function fn_postSubmit(url, params) {
  const form = document.createElement("form");
  form.method = "post";
  form.action = url;

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.type = "hidden";
    hiddenField.name = key;
    hiddenField.value = params[key];

    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.target = "_blank";
  form.submit();
  form.remove();
}

export function console(data) {
  if (process.env.NODE_ENV === "development") {
    window.console.log(data);
  }
}
